export enum RouterFragments {
  UNKNOWN = 'unknown'
}
